<template>
  <div class="dir-upload-docs">
    <label>{{ $t('directory.label.documents') }}</label>
    <HkldDropzone
      v-if="allowEdit"
      :sourceId="currentDirectory.id || ''"
    />
    <EditAttachments
      :canDelete="allowEdit"
      :canEdit="allowEdit"
      :sourceId="currentDirectory.id"
      :showAllDeleteBtn="false"
      :showDeleteBtnFunc="showDeleteBtnFunc"
      :showEmptyMsg="!allowEdit"
      :emptyMsg="$t('directory.msg.emptyDocHint')"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters } from 'vuex'

import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'
import { directoryRouteNames, UserSource } from '@/utils/consts'
import { DIR_STATUS, DIR_ACTION, tenantCreatorEditableStatus } from './consts'

export default {
  name: 'UploadDocs',
  components: {
    EditAttachments,
    HkldDropzone,
  },
  methods: {
    showDeleteBtnFunc (item) {
      let result = true
      // Can only edit own group files.
      const creator = lodash.get(item, 'creator')
      const sameGroup = (this.isEngineer && creator.source === UserSource.AD) || (!this.isEngineer && creator.source === UserSource.EXT)
      if (!sameGroup && !this.canBothEdit) {
        result = false
      }
      return result
    },

  },
  computed: {
    ...mapGetters('user', ['isTenant', 'isEngineer']),
    ...mapGetters('directories', ['currentDirectory', 'tenancyInfo', 'canCurrUserApprove', 'canCurrUserCreate']),

    allowEdit () {
      return this.canBothEdit || this.canEngineerEdit
    },
    canBothEdit () {
      return this.canCurrUserCreate && (this.isRemoveInPublish || tenantCreatorEditableStatus.includes(this.currentDirectory.status))
    },
    isRemoveInPublish () {
      const isRemoveAction = [directoryRouteNames.tenantDirectories, directoryRouteNames.tenancyDirectories].includes(this.$router.currentRoute.query.fromPage)
      return (isRemoveAction && DIR_STATUS.PUBLISHED === this.currentDirectory.status && DIR_ACTION.ADD === this.currentDirectory.action)
    },
    canEngineerEdit () {
      const canEditPerms = aclHelper.getAccess(tmsPermsTypes.directory.maintain) || aclHelper.getAccess(tmsPermsTypes.directory.createUpdate) ||
      aclHelper.getAccess(tmsPermsTypes.directory.approve) || aclHelper.getAccess(tmsPermsTypes.directory.removeFromMaintain)
      const canEditInPublish = this.currentDirectory.action === DIR_ACTION.ADD && DIR_STATUS.PUBLISHED === this.currentDirectory.status
      const hklEditableStatus = [DIR_STATUS.SUBMITTED, DIR_STATUS.APPR, DIR_STATUS.PROCESSED]
      return canEditPerms && (hklEditableStatus.includes(this.currentDirectory.status) || canEditInPublish)
    },
    publishedAt () {
      return lodash.get(this.currentDirectory, 'publishedAt')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/directories/detail';
</style>
